import { stdObject } from "../data/types/stdObject";
import { processPersonsData } from "../utils/processPersonsData";
import { sendData } from "./sendData";

export const callPersons = async ({
  type,
  searchList,
  sort = false,
  print = false,
  logoutAction,
}: {
  type: string;
  searchList: stdObject;
  sort?: stdObject | boolean;
  print?: boolean;
  logoutAction: any;
}) => {
  const payloadPersonsService = {
    type,
    searchList,
    sort,
    print,
  };
  // console.log("payloadPersonsService", payloadPersonsService);

  const responsePersonsService: {
    [key: string]: any;
  } = await sendData({
    endPoint: "callPersonsList",
    payload: payloadPersonsService,
    logoutAction,
  });
  // console.log("responsePersonsService", responsePersonsService);

  if (responsePersonsService.success) {
    responsePersonsService.list = processPersonsData(
      type,
      responsePersonsService.list,
    );
    return responsePersonsService.list;
  } else {
    return [];
  }
};
